import React from 'react';
import CommonOperationScreen from '../../components/CommonOperationScreen/CommonOperationScreen';

const Rbt = () => {
	return <CommonOperationScreen operationName="RBT" buttonLabel="Mark RBT Complete" />;
};

export default Rbt;
